import * as React from 'react';
import { Link } from 'react-router-dom';
import { UitkSelect } from 'uitk-react-select';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { ViewLarge, Viewport, ViewSmall } from 'bernie-view';
import { RoomComponentPackageMobile as RoomComponentMobile } from './room-component-package-mobile';
import { RoomComponentPackageDesktop as RoomComponentDesktop } from './room-component-package-desktop';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';

export interface RoomComponentPackageProps {
  onAdultCountChange(event: any): void;
  onChildCountChange(event: any): void;
  onInfantCountChange(event: any): void;
  roomCount: any;
  childComponent: any;
}
export class RoomComponentPackage extends React.Component<RoomComponentPackageProps, any> {
  public constructor(props) {
    super(props);
  }

  public renderAdults() {
    const adultArray = [1, 2, 3, 4, 5, 6];
    let opt;

    return adultArray.map((adult) => {
      if (adult > 1) {
        opt = (
          <option key={adult} value={adult}>
            {adult} Adults
          </option>
        );
      } else {
        opt = (
          <option key={adult} value={adult}>
            {adult} Adult
          </option>
        );
      }

      return opt;
    });
  }

  public renderKids() {
    const childArray = [0, 1, 2, 3, 4, 5, 6];
    let opt;

    return childArray.map((child) => {
      if (child > 1 || child < 1) {
        opt = (
          <option key={child} value={child}>
            {child} Children
          </option>
        );
      } else {
        opt = (
          <option key={child} value={child}>
            {child} Child
          </option>
        );
      }

      return opt;
    });
  }

  public renderInfants() {
    const infantArray = [0, 1, 2, 3, 4, 5, 6];
    let opt;

    return infantArray.map((infant) => {
      if (infant > 1 || infant < 1) {
        opt = (
          <option key={infant} value={infant}>
            {infant} Infants
          </option>
        );
      } else {
        opt = (
          <option key={infant} value={infant}>
            {infant} Infant
          </option>
        );
      }

      return opt;
    });
  }

  public render() {
    const { onAdultCountChange, onChildCountChange, roomCount, onInfantCountChange } = this.props;
    const roomLabel = `Room ${roomCount}`;

    return (
      <>
        <UitkSpacing padding={{ blockstart: 'six' }}>
          <UitkHeading tag="h2" size={5}>
            {roomLabel}
          </UitkHeading>
        </UitkSpacing>

        <Viewport>
          <ViewLarge>
            <>
              <UitkLayoutGrid columns={4} space="three">
                <>
                  <UitkLayoutGridItem>
                    <div>
                      <UitkText align="left" size={300} weight="bold">
                        Adults
                      </UitkText>
                      <UitkSelect
                        id={`adultCount${roomCount}`}
                        label=""
                        icon="person"
                        onChange={onAdultCountChange}
                        hasVisibleLabel={false}
                      >
                        {this.renderAdults()}
                      </UitkSelect>
                    </div>
                  </UitkLayoutGridItem>
              <UitkLayoutGridItem>
                <div>
                  <UitkText align="left" size={300} weight="bold">
                    Children (Ages 2-17)
                  </UitkText>
                <UitkSelect
                  id={`child-count${roomCount}`}
                  label=""
                  icon="person"
                  onChange={onChildCountChange}
                  hasVisibleLabel={false}
                >
                  {this.renderKids()}
                </UitkSelect>
              </div>
              </UitkLayoutGridItem>

              <UitkLayoutGridItem>
                <div>
                <UitkText align="left" size={300} weight="bold">
                  Infants (Age under 2)
                </UitkText>
                <UitkSelect
                  id={`infantCount${roomCount}`}
                  label=""
                  icon="person"
                  onChange={onInfantCountChange}
                  hasVisibleLabel={false}
                >
                  {this.renderInfants()}
                </UitkSelect>
              </div>
              </UitkLayoutGridItem>
              <RoomComponentDesktop roomCount={this.props.roomCount} childComponent={this.props.childComponent} />
            </>
                </UitkLayoutGrid>
              </>

          </ViewLarge>

          <ViewSmall>
            <>
                <UitkText align="left" size={300} weight="bold">
                  Children (Ages 2-17)
                </UitkText>
                <UitkSelect
                  id={`child-count${roomCount}`}
                  label=""
                  icon="person"
                  onChange={onChildCountChange}
                  hasVisibleLabel={false}
                >
                  {this.renderKids()}
                </UitkSelect>

              <RoomComponentMobile roomCount={this.props.roomCount} childComponent={this.props.childComponent} />


                <UitkText align="left" size={300} weight="bold">
                  Infants (Age under 2)
                </UitkText>
                <UitkSelect
                  id={`infantCount${roomCount}`}
                  label=""
                  icon="person"
                  onChange={onInfantCountChange}
                  hasVisibleLabel={false}
                >
                  {this.renderInfants()}
                </UitkSelect>

            </>
          </ViewSmall>
        </Viewport>
      </>
    );
  }
}
